import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { classNames, useTranslate } from "helpers/common";
import { SidebarChildItemProps } from "./types";

const MenuItem: React.FC<SidebarChildItemProps> = (props) => {
  const { text, icon, route, count, isParentHovered } = props;

  const { t } = useTranslate();

  return (
    <li className="relative">
      <NavLink
        end
        to={route}
        className={({ isActive }) =>
          classNames(
            "relative rounded-md text-sm font-medium",
            !isParentHovered &&
              "before:absolute before:top-0 before:-left-6 before:h-full before:w-5 before:border-l-2 before:transition-colors",
            isActive
              ? "text-[#f6fafb] before:border-[#f6fafb]"
              : "text-[#888a97] before:border-[#888a97] hover:before:border-[#edeef8]"
          )
        }
      >
        {({ isActive }) => (
          <div
            className={classNames("group h-12 flex items-center relative pr-3")}
          >
            <div className="pr-1">
              <div className="w-6 h-6 flex items-center">
                <ReactSVG
                  src={icon}
                  className={classNames(
                    "w-5 h-5 transition-colors",
                    isActive
                      ? "text-[#f6fafb] stroke-[#f6fafb]"
                      : "text-[#888a97] stroke-[#888a97] group-hover:text-[#f6fafb] group-hover:stroke-[#f6fafb]"
                  )}
                />
              </div>
            </div>
            <div
              className={classNames(
                "grow transition-colors duration-200 ease-out group-hover:text-[#edeef8]"
              )}
            >
              {t(text)}
            </div>
            {count && (
              <span className="flex-none relative text-[10px] font-normal ml-3 inline-flex items-center justify-center rounded h-5 w-5 bg-[#51bffc] text-[#f6fafb]">
                {count}
              </span>
            )}
          </div>
        )}
      </NavLink>
    </li>
  );
};
export default MenuItem;
